const autocompleteFromCreateUser = {
  site: 'Sites',
  companies: 'Empresa Terceira'
};

export default autocompleteFromCreateUser;
